var _path, _path2, _path3, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStartTimeSmall = function SvgStartTimeSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2L1 4",
    stroke: "#15BD5D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2L15 4",
    stroke: "#2F353B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16669 5.85712C8.16669 5.58097 7.94283 5.35712 7.66669 5.35712C7.39054 5.35712 7.16669 5.58097 7.16669 5.85712H8.16669ZM7.66669 8.33331H7.16669C7.16669 8.60945 7.39054 8.83331 7.66669 8.83331V8.33331ZM10.1429 8.83331C10.419 8.83331 10.6429 8.60945 10.6429 8.33331C10.6429 8.05717 10.419 7.83331 10.1429 7.83331V8.83331ZM7.16669 5.85712V8.33331H8.16669V5.85712H7.16669ZM7.66669 8.83331H10.1429V7.83331H7.66669V8.83331Z",
    fill: "#15BD5D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99998,
    cy: 7.99998,
    r: 5.16667,
    stroke: "#2F353B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartTimeSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start-time-small.f2e74a2b.svg";
export { ForwardRef as ReactComponent };